var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60522 6.95114C3.60522 5.10317 5.21931 3.6051 7.21038 3.6051H21.631C23.6221 3.6051 25.2361 5.10317 25.2361 6.95114V18.1046C25.2361 19.9525 23.6221 21.4506 21.631 21.4506H7.21038C5.21931 21.4506 3.60522 19.9525 3.60522 18.1046V6.95114Z",
    fill: "#3448FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9086 7.23053C13.3106 7.2442 13.6542 7.50351 13.7506 7.86602L15.3799 13.9924L16.2827 12.9085C16.4534 12.7036 16.7167 12.5836 16.9958 12.5836H21.631C22.1288 12.5836 22.5323 12.9581 22.5323 13.4201C22.5323 13.8821 22.1288 14.2566 21.631 14.2566H17.4382L15.665 16.3855C15.4535 16.6394 15.1041 16.7587 14.7658 16.6924C14.4275 16.6261 14.1598 16.3859 14.0769 16.0744L12.7556 11.1061L11.8622 13.6491C11.7412 13.9933 11.3954 14.2262 11.0053 14.2262H7.21038C6.71261 14.2262 6.30909 13.8517 6.30909 13.3897C6.30909 12.9277 6.71261 12.5532 7.21038 12.5532H10.3512L12.0187 7.80714C12.1435 7.45215 12.5066 7.21686 12.9086 7.23053Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01295 24.1545C9.01295 23.5572 9.55098 23.0729 10.2147 23.0729H18.6267C19.2904 23.0729 19.8284 23.5572 19.8284 24.1545C19.8284 24.7518 19.2904 25.236 18.6267 25.236H10.2147C9.55098 25.236 9.01295 24.7518 9.01295 24.1545Z",
    fill: "url(#paint0_linear_1668_2998)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_2998",
    x1: 14.4207,
    y1: 3.6051,
    x2: 14.4207,
    y2: 25.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D18BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown4);
export default __webpack_public_path__ + "static/media/icon-dropdown4.530e3711c30e6475c0dd40f3288c0986.svg";
export { ForwardRef as ReactComponent };